export const OverclaimShareDisplayHelper = (share: number | undefined) =>
    share && +(share - 100) >= 0 ? +(share - 100).toFixed(2) : 0
